<script>
import AddLabelButton from '@/src/components/AddLabelButton.vue';
import ApiModeVuetable from '@/src/components/ApiModeVuetable.vue';
import Breadcrumb from '@/src/components/Breadcrumb.vue';
import CountTableButton from '@/src/components/CountTableButton.vue';
import ImportButton from '@/src/components/ImportButton.vue'
import ExportButton from '@/src/components/ExportButton.vue';
import FilterLabelButton from '@/src/components/FilterLabelButton.vue';
import MoreTableButton from '@/src/components/MoreTableButton.vue';
import PageHeader from '@/src/components/PageHeader.vue';
import userChildrenFields from '@/src/fields/childrens/userChildrenFields.vue';
import FilterBar from '@components/FilterBar';
import Layout from '@layouts/main';
import GridFormModal from '@src/components/GridFormModal.vue';
import filterVuetable from '@src/mixins/filterVuetable';
import pagination from '@src/mixins/pagination';
import swalFeedback from '@src/mixins/swalFeedback';
import TeamsService from '@src/services/TeamsService';
import teamsFilterModal from '@views/teams/teamsFilterModal';
import teamsModal from '@views/teams/teamsModal';
import importModal from '@views/importJob/importJobModal'
import { debounce } from 'lodash';

const i18nCommon = 'COMMON'
const i18nKey = 'TEAMS'

export default {
    components: {
        ApiModeVuetable,
        Breadcrumb,
        PageHeader,
        Layout,
        importModal,
        teamsModal,
        teamsFilterModal,
        GridFormModal,
        FilterBar,
        FilterLabelButton,
        AddLabelButton,
        CountTableButton,
        MoreTableButton,
        ExportButton,
        ImportButton,
    },
    mixins: [swalFeedback, pagination, filterVuetable, userChildrenFields],
    data() {
        return {
            sortOrder: [
                {
                    field: 'name',
                    direction: 'asc',
                },
            ],
            i18nCommon,
            i18nKey,
            submitLoading: false,
            additionalParameters: {
                with: ['leader'],
                withCount: 'users',
            },
            modalIsEdit: false,
            modal: {
                id: 0,
                name: '',
                leader_id: null,
                leader: null,
                users: [],
                mirror_of_team_id: null,
            },
            data: [],
            perPage: 10,
            fields: [
                {
                    name: 'name',
                    title: this.getI18n(i18nCommon, 'name'),
                    sortField: 'name',
                },
                {
                    name: 'leader.name',
                    title: this.getI18n(i18nCommon, 'supervisor'),
                    sortField: 'users:leader_id|users.name',
                },
                {
                    name: 'users',
                    title: this.getI18nModified({
                        prefix: 'USERS',
                        suffix: 'TITLES.user',
                        modifier: 2,
                    })
                },
                {
                    name: 'actions',
                    title: '',
                },
            ],
            css: {},
            loadingEdit: [],
            loadingGrid: false,
            filterText: '',
            filters: {
                leader: [],
                leader_id: [],
            },
        }
    },
    computed: {
        items() {
            return [
                {
                    text: 'Home',
                    href: '/',
                },
                {
                    text: this.getI18nModified({
                        prefix: 'USERS',
                        suffix: 'TITLES.collaborator',
                        modifier: 2,
                    }),
                    active: true,
                },
                {
                    text: this.getI18nModified({
                        prefix: 'TEAMS',
                        suffix: 'TITLES.team',
                        modifier: 2,
                    }),
                    active: true,
                },
            ]
        },
        i18nName() {
            return this.getI18n(i18nCommon, 'name')
        },
        i18nNewTeam() {
            return this.getI18n(i18nKey, 'BUTTONS.new_team')
        },
        teamsRefs() {
            return this.$refs;
        }
    },
    watch: {
        filterText: debounce(function (searchText) {
            this.additionalParameters = {
                with: ['leader'],
                withCount: 'users',
                search: '',
            }
            if (searchText && searchText.length > 0) {
                this.additionalParameters.search = `name:${searchText};leader.name:${searchText}`
            }
            this.refreshTable()
        }, 1000),
    },

    methods: {
        fetch(url, params) {
            return TeamsService.fetchVuetable(url, params)
        },

        i18nTeam(modifier) {
            return this.getI18nModified({
                prefix: i18nKey,
                suffix: 'TITLES.team',
                modifier: modifier,
            })
        },

        cleanModal() {
            this.replaceModalData({
                id: 0,
                name: '',
                leader_id: null,
                leader: null,
                users: [],
                mirror_of_team_id: null,
            })
        },

        createAdditionalParameters() {
            return this.formatParameters({
                with: ['leader'],
                leader_id: this.filters.leader.map((leader) => leader.id),
            })
        },

        filter(appliedFilters) {
            this.filters = appliedFilters;
            this.additionalParameters = this.formatParameters({
                with: ['leader'],
                withCount: 'users',
                leader_id: this.filters.leader.map((leader) => leader.id),
            })
            this.refreshTable()
        },

        showFilterModal() {
            this.$nextTick(() => this.$refs.teamFilterModal.showModal(this.filters))
        },
        showModal() {
            this.$nextTick(() => this.$refs.teamModal.showModal())
        },
        showImportModal() {
            this.$nextTick(() => this.$refs.importModal.showModal())
        },
        openModalToCreate() {
            this.modalIsEdit = true
            this.cleanModal()
            this.showModal()
        },

        async openModalToEdit(data, index, event) {
            this.loadingEdit.push(data.id)
            this.modalIsEdit = false
            this.replaceModalData(data)
            this.showModal()
            this.loadingEdit.splice(
                this.loadingEdit.findIndex((el) => el === data.id),
                1
            )
        },

        openModalUsers(data) {
            this.loadingGrid = true
            this.$nextTick(() => this.$refs.gridUsersModal.showModal(data.name))
            TeamsService.fetchById(data.id, {
                with: ['users']
            }).then(response => {
                this.replaceModalData(response.data.data);
                this.$refs.gridUsersModal.refreshTable();
                this.loadingGrid = false
            })
            .catch(() => {
                this.loadingGrid = false
            })
        },

        replaceModalData(data) {
            this.modal = Object.assign(this.modal, data)

            this.modal.leader_id = this.modal.leader ? this.modal.leader.id : null

            Object.assign(this.modal, {
                users: []
            })

            Object.assign(this.modal.users, data.users)
        },

        reloadTable() {
            this.$refs.vuetable.reload()
        },

        refreshTable() {
            this.$refs.vuetable.refresh()
        },
    },
}
</script>

<template>
    <Layout>
        <div class="col-12">
            <Breadcrumb :items="items" />
            <div class="row mt-3 mb-3">
                <div class="col-sm-6 form-inline">
                    <filter-bar v-model="filterText"/>
                    <filter-label-button @onClick="showFilterModal" />
                </div>

                <div class="col-sm-6">
                    <div class="d-flex justify-content-end gap-2 text-sm-right">
                        <add-label-button
                            v-if="$can('CREATE', 'TEAM')"
                            :title="i18nNewTeam"
                            @onClick="openModalToCreate"
                        />
                        <import-button
                            v-if="$can('CREATE', 'IMPORTJOB')"
                            @onClick="showImportModal"
                        />
                        <export-button
                            v-if="$can('CREATE', 'EXPORTJOB')"
                            type="team"
                            :create-parameters="createAdditionalParameters"
                            :vuetable-ref="productsCategoriesRefs"
                        />
                    </div>
                </div>
            </div>
            <div class="card card-pdv">
                <PageHeader :title="i18nTeam(2)" />
                <div class="card-body">
                    <api-mode-vuetable
                        ref="vuetable"
                        :fetch-data="fetch"
                        :fields="fields"
                        :per-page="perPage"
                        :additional-parameters="additionalParameters"
                        :sort-order="sortOrder">
                        <template slot="users" slot-scope="props">
                            <count-table-button :value="props.rowData.users_count ?? 0" @onClick="openModalUsers(props.rowData)" />
                        </template>
                        <template slot="actions" slot-scope="props">
                            <div class="table-button-container">
                                <more-table-button @onClick="openModalToEdit(props.rowData)" />
                            </div>
                        </template>
                    </api-mode-vuetable>
                </div>
            </div>
        </div>
        <teams-modal
            ref="teamModal"
            :modal="modal"
            :modal-is-edit="modalIsEdit"
            @refresh="reloadTable"
        />
        <grid-form-modal
            ref="gridUsersModal"
            :modal="modal"
            :busy="loadingGrid"
            :items="modal.users"
            :fields="userChildrenFields"
            :title="getI18nModified({
                        prefix: 'USERS',
                        suffix: 'TITLES.user',
                        modifier: 2,
                    })"
        />
        <teams-filter-modal
            ref="teamFilterModal"
            :handle-submit="filter"
        />
        <import-modal
            ref="importModal"
            :csv-type="'team'"
            :title="
                getI18nModified({
                    prefix: 'IMPORT_JOBS',
                    suffix: 'TITLES.team',
                    modifier: 2,
                })
            "
        />
    </Layout>
</template>
